import { c as _c } from "react/compiler-runtime";
import { DemoTag } from "@components/common/demo-tag";
import { FaroCardImage } from "@components/common/faro-card/faro-card-image";
import { Box } from "@mui-wrapper";
import { unstyledLinkSx } from "@styles/common-styles";
import { defaultProjectThumbnail, isProjectDemo } from "@utils/project-utils";
import { Link } from "react-router-dom";
/**
 * The top section of a card that shows the project thumbnail.
 */
export function ProjectCardTop(t0) {
  const $ = _c(13);
  const {
    project,
    thumbnailLinkTo,
    onThumbnailClick
  } = t0;
  const t1 = project.thumbnailUrl ?? defaultProjectThumbnail;
  let t2;
  if ($[0] !== project.id || $[1] !== project.name || $[2] !== t1) {
    t2 = <FaroCardImage src={t1} fallbackSrc={defaultProjectThumbnail} alt={project.name} shouldNotTranslate={true} contextType="project" contextId={project.id} />;
    $[0] = project.id;
    $[1] = project.name;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const thumbnailImage = t2;
  let t3;
  if ($[4] !== onThumbnailClick || $[5] !== thumbnailImage || $[6] !== thumbnailLinkTo) {
    t3 = thumbnailLinkTo ? <Box component={Link} to={thumbnailLinkTo} onClick={onThumbnailClick} sx={unstyledLinkSx}>{thumbnailImage}</Box> : thumbnailImage;
    $[4] = onThumbnailClick;
    $[5] = thumbnailImage;
    $[6] = thumbnailLinkTo;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== project) {
    t4 = isProjectDemo(project) && <DemoTag sx={{
      position: "absolute",
      top: "15px",
      left: "15px"
    }} />;
    $[8] = project;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}